module.exports = __webpack_public_path__ + "static/img/silver_two.702dad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/silver_two.png
// module id = Z/MD
// module chunks = 1